import React, { useMemo, useCallback } from 'react';
import { Form } from 'react-final-form';
import { Button } from '@/shared/components/Button';
import { Card, CardBody } from '@/shared/components/Card';
import { FormButtonToolbar, FormContainer } from '@/shared/components/form/FormElements';
import { formStructure, formSections } from './formConfig';
import DynamicForm from '../../../../../shared/components/form/DynamicForm';
import { post } from '@/utils/api/base';

const mapFormToCreateApi = (values) => {
  // Formatar a data do formulário para o formato da API (YYYY-MM-DD)
  const formatarDataParaAPI = (data) => {
    if (!data) {
      // Se não houver data, usar data atual
      return new Date().toISOString().slice(0, 19).replace('T', ' ');
    }
    
    // Se for um objeto Date, converter para string
    if (data instanceof Date) {
      return data.toISOString().slice(0, 19).replace('T', ' ');
    }
    
    // Se for uma string, tentar converter
    try {
      const dataObj = new Date(data);
      return dataObj.toISOString().slice(0, 19).replace('T', ' ');
    } catch (error) {
      console.error('Erro ao formatar data:', error);
      return new Date().toISOString().slice(0, 19).replace('T', ' ');
    }
  };

  return {
    DataDisponibilidade: formatarDataParaAPI(values.DataDisponibilidade),
    LocalCidade: values.vazioem,
    LocalEstado: values.uf,
    Frota: values.frota,
    Veiculo: "ABC-1234",
    NomeGestor: values.gestor,
    Vazio: values.vazio || false,
    Coleta: values.coleta || false,
    Negociacao: values.negociacao || false,
    NomeComercial: values.responsavelComercial,
    Destino: values.destino,
    UsuarioCriacao: 'usuario',
  };
};

const createDisponibilidade = async (payload) => {
  const response = await post(`${process.env.REACT_APP_BASE_API_URL}/frotas/disponibilidade/criar`, payload);
  return response.data;
};

const Forms = () => {
  const onSubmit = useCallback(async (values) => {
    try {
      const payload = mapFormToCreateApi(values);
      await createDisponibilidade(payload);
      alert('Disponibilidade criada com sucesso!');
      window.location.href = '/pages/programacao/disponibilidade';
    } catch (err) {
      alert(`Erro ao criar disponibilidade: ${err.message}`);
    }
  }, []);

  const initialValues = useMemo(() => ({
    frota: '',
    segmento: '',
    destino: '',
    responsavelComercial: '',
    uf: '',
    diasParados: 0,
    DataDisponibilidade: new Date(),
    gestor: '',
    vazioem: '',
    vazio: false,
    coleta: false,
    negociacao: false,
  }), []);

  return (
    <Form onSubmit={onSubmit} initialValues={initialValues}>
      {({ handleSubmit, form: { reset } }) => (
        <Card>
          <CardBody>
            <FormContainer onSubmit={handleSubmit}>
              <DynamicForm
                structure={formStructure}
                sections={formSections(initialValues)}
              />
              <FormButtonToolbar className="mt-5">
                <Button variant="primary" type="submit">Salvar</Button>
                <a href="/pages/programacao/disponibilidade">
                  <Button variant="secondary" type="button">Cancelar</Button>
                </a>
              </FormButtonToolbar>
            </FormContainer>
          </CardBody>
        </Card>
      )}
    </Form>
  );
};

export default Forms;